import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import {
  DashboardWidgetBlueprint,
  MyWorkCardBlueprint,
} from '@platform/plugin-platform-react';

/**
 * Le module DORA côté frontend. Son backend, `@platform/plugin-dora-backend`,
 * existait seul : ses widgets étaient câblés en dur dans deux pages du noyau,
 * le tableau de bord et « Mon travail ». Le profil client minimal (phase 5)
 * les a montrés en erreur 404 chez un client sans ce module.
 *
 * Même `pluginId` que le backend : le triplet plugin / backend est complet.
 * Il enrichit les pages du noyau et porte aussi sa page « Performance DORA » (/dora).
 */
// Vue d'ensemble (maquette) : performance (colonne principale), activité et MR (colonne latérale).
// La vue complète, avec les services dégradés, est sur la page « Performance DORA ».
const doraPerformanceWidget = DashboardWidgetBlueprint.make({
  name: 'dora-performance',
  params: { area: 'main', loader: () => import('./components/dashboardWidgets').then(m => <m.DoraPerformanceWidget />) },
});
const doraActivityWidget = DashboardWidgetBlueprint.make({
  name: 'dora-activity',
  params: { area: 'side', loader: () => import('./components/dashboardWidgets').then(m => <m.DoraActivityWidget />) },
});
const doraStaleMrsWidget = DashboardWidgetBlueprint.make({
  name: 'dora-stale-mrs',
  params: { area: 'side', loader: () => import('./components/dashboardWidgets').then(m => <m.DoraStaleMrsWidget />) },
});

const myChangesCard = MyWorkCardBlueprint.make({
  name: 'my-changes',
  params: {
    width: 'wide',
    loader: () =>
      import('./components/MyChangesCard').then(m => <m.MyChangesCard />),
  },
});

const doraPage = PageBlueprint.make({
  params: {
    path: '/dora',
    // La page porte son propre en-tête (Header) : pas de barre de titre automatique.
    noHeader: true,
    loader: () => import('./components/DoraPage').then(m => <m.DoraPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'dora',
  extensions: [doraPerformanceWidget, doraActivityWidget, doraStaleMrsWidget, myChangesCard, doraPage],
});
